import { CSSProperties, useEffect, useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import WebApp from '@twa-dev/sdk'

import { useValueContext, ValueContext } from 'contexts'
import { isDefAndNotEmpty } from 'utils'
import { PageSpinner } from 'components'
import { FlexLayout } from 'layouts'

import './styles.scss'
import { Screens } from './Screens'

const footerSelector = '.welcome-page .slider-footer'
const dotsSelector = '.welcome-page .slick-dots'

const onHideSliderNav = () => {
  document.querySelector(footerSelector)?.classList.add('hidden')
  document.querySelector(dotsSelector)?.classList.add('hidden')
}

const onShowSliderNav = () => {
  document.querySelector(footerSelector)?.classList.remove('hidden')
  document.querySelector(dotsSelector)?.classList.remove('hidden')
}

export const Welcome = observer(() => {
  const store = useValueContext()
  const navigate = useNavigate()
  const [vh, setVh] = useState(WebApp.viewportHeight)

  const { babies, loading } = store

  // useLayoutEffect для избежания "мерцания" экрана перед редиректом
  useLayoutEffect(() => {
    if (isDefAndNotEmpty(babies)) {
      navigate('/home')
    }
  }, [babies, navigate])

  useEffect(() => {
    const onViewportChange = () => {
      if (WebApp.viewportHeight > vh) {
        setVh(WebApp.viewportHeight)
      } else {
        onHideSliderNav()
      }

      if (WebApp.viewportHeight >= vh) {
        onShowSliderNav()
      }
    }

    WebApp.onEvent('viewportChanged', onViewportChange)

    return () => {
      WebApp.offEvent('viewportChanged', onViewportChange)
    }
  }, [vh])

  return (
    <ValueContext.Provider value={store}>
      {loading ? (
        <PageSpinner delay={400} minVisibleTime={400} open opaque />
      ) : (
        <FlexLayout.Container
          style={{ '--original-vh': `${vh}px` } as CSSProperties}
          className="welcome-page with-mobile-indent"
          vertical
        >
          <FlexLayout.Content scrollable={false}>
            <div className="welcome-header">
              Добро пожаловать в <span>Baby Tracker</span>
            </div>
            <Screens />
          </FlexLayout.Content>
        </FlexLayout.Container>
      )}
    </ValueContext.Provider>
  )
})
